import ReferModal from './ReferModal'

export default ReferModal



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/refer/index.jsx